/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnergyResponse } from '../../models/energy-response';

export interface GetLatestEnergyReading$Params {
  location_id: string;
}

export function getLatestEnergyReading(http: HttpClient, rootUrl: string, params: GetLatestEnergyReading$Params, context?: HttpContext): Observable<StrictHttpResponse<EnergyResponse>> {
  const rb = new RequestBuilder(rootUrl, getLatestEnergyReading.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnergyResponse>;
    })
  );
}

getLatestEnergyReading.PATH = '/locations/{location_id}/energy-readings/latest';
